/**
 * Playback History API client — fetch playback logs for a location (web)
 */
import { apiClient } from '../../../services/apiClient';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface TrackInfoDto {
  id: string;
  title: string;
  artist?: string | null;
  durationSeconds: number;
  category: string;
  thumbnailUrl?: string | null;
}

export interface PlaybackLogEntryDto {
  id: string;
  track: TrackInfoDto;
  playedAt: string;
  durationPlayed: number;
  completed: boolean;
  clientType: string;
}

export interface PlaybackHistoryPageDto {
  items: PlaybackLogEntryDto[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface PlaybackHistoryParams {
  locationId: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  pageSize?: number;
}

// ---------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------

export function getPlaybackHistory(
  params: PlaybackHistoryParams,
): Promise<PlaybackHistoryPageDto> {
  const { locationId, startDate, endDate, page, pageSize } = params;
  return apiClient.get<PlaybackHistoryPageDto>(
    `/api/v1/player/locations/${locationId}/history`,
    { startDate, endDate, page, pageSize },
  );
}
